import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    width: "100%",
    height: "100%",
    position: "relative"
  },
  cta: {
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    background: "rgba(255, 255, 255, 0.2)"
  },
  ctaBg: {
    width: 350,
    height: 350,
    position: "absolute",
    zIndex: 0,
    opacity: 0.05
  },
  ctaContent: {
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: 32,
    padding: "0 16px"
  },
  ctaTitle: {
    color: theme.palette.text.primary,
    fontSize: 16,
    margin: 0,
    lineHeight: "41px"
  },
  ctaSubTitle: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    margin: "0 0 14px 0",
    lineHeight: "41px",
    textAlign: "center"
  },
  tableContainer: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: "hidden"
  },
  scrollableContainer: {
    maxHeight: `calc(100dvh - 220px)`,
    overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      maxHeight: `calc(100dvh - 236px)`
    },
    [theme.breakpoints.down("xs")]: {
      maxHeight: "100%"
    }
  },
  tableHead: {
    height: 48,
    "& .MuiTableRow-root:last-child .MuiTableCell-root": {
      borderBottom: `1px solid ${theme.palette.text.hint}`
    },
    [theme.breakpoints.down("xs")]: {
      display: "none"
    }
  },
  tableHeadCell: {
    width: "20%",
    borderBottom: `1px solid ${theme.palette.text.hint}`,
    color: theme.palette.text.hint,
    background: theme.palette.common.white
  },
  dark: {
    color: theme.palette.text.secondary
  },
  tableRow: {
    height: 36,
    cursor: "pointer",
    "& .MuiTableCell-root": {
      color: theme.palette.text.secondary
    }
  },
  tableRowActive: {
    "& .MuiTableCell-root": {
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      color: theme.palette.text.primary
    }
  },
  wrench: {
    fontSize: 12,
    marginRight: 8
  },
  tableCell: {
    width: "20%"
  },
  tableCellDate: {
    textAlign: "left",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center"
    }
  },
  [`status-${racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_OPEN}`]: {
    color: "#f47844"
  },
  [`status-${racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_ASSIGNED}`]: {
    color: "#4269B5"
  },
  [`status-${racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_CANCELED}`]: {
    color: theme.palette.text.secondary
  },
  [`status-${racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_CLOSED}`]: {
    color: theme.palette.secondary.dark
  },
  [`status-${racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_COMPLETE}`]: {
    color: theme.palette.secondary.dark
  },
  hideDownSX720: {
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      display: "none"
    }
  },
  noBreak: {
    whiteSpace: "nowrap"
  }
}));
